<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-6">
						<div class="avatar-upload-histequipo">
							<div class="avatar-edit">
                                <input id="file" @change="CambiarImagen($event)" ref="file" type="file" name="file" accept=".png, .jpg, .jpeg">
                                <label for="file"></label>
                            </div>
							<div class="avatar-preview">
                                <div id="imagePreview" style="background-image: url(Img);">
                                </div>
                            </div>
						</div>
					</div>
					<div class="col-lg-6">
						<div class="row">
							<div class="col-lg-12">
								<label for="">Nombre</label>
								<input type="text" class="form-control" v-model="Usuario.Nombre" placeholder="Nombre"/>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col-lg-12">
								<label for="">Correo</label>
								<input type="text" class="form-control" v-model="Usuario.Candado" placeholder="Nombre"/>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col-lg-12">
								<label for="">Contraseña</label>
								<input type="password" class="form-control" v-model="Usuario.Seguridad" placeholder="Apellido"/>
							</div>
						</div>
					</div>
					<!-- <div class="col-lg-12">
						<label for="">Nombre</label>
						<input type="text" class="form-control" v-model="Usuario.Nombre" placeholder="Nombre"/>
					</div>
					<div class="col-lg-12 mt-3">
						<label for="">Correo</label>
						<input type="text" class="form-control" v-model="Usuario.Candado" placeholder="Correo"/>
					</div>
					<div class="col-lg-12 mt-3">
						<label for="">Contraseña</label>
						<input type="password" class="form-control" v-model="Usuario.Seguridad" placeholder="Contraseña"/>
					</div> -->
				</div>
			</template>
		</CLoader>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue';
import Cvalidation from '@/components/Cvalidation.vue';
import Config from "@/helpers/VarConfig.js";
import $$ from "jquery";
export default {
	name:'DistribuidorForm',
	props:["poBtnSave"],
	components:{
		Cbtnsave,
        Cvalidation,
	},
	data() {
		return {
			Modal:true,
			FormName:'distribuidor',
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ValidElement:Config.validImage2m,
			Usuario:{
				IdUsuario:0,
				Nombre:'',
				// Apellido:'',
				Candado:'',
				Seguridad:'',
				Foto2:'',
				Distribuidor:1,
			},
			ConfigLoad:{
				ShowLoader: false,
				ClassLoad:  true,
			},
			errorvalidacion:[],
			Foto:''
		}
	},
	methods: {
		async Guardar(){
			let formData=new FormData();
			let image=this.$refs.file.files[0];
			this.ConfigLoad.ShowLoader = true;
			formData.set('IdUsuario',this.Usuario.IdUsuario);
			formData.set('Nombre',this.Usuario.Nombre);
			// formData.set('Apellido',this.Usuario.Apellido);
			formData.set('Distribuidor',this.Usuario.Distribuidor);
			formData.set('Foto2',this.Usuario.Foto2);
			formData.set('Candado',this.Usuario.Candado);
			formData.set('Seguridad',this.Usuario.Seguridad);
			formData.append('Foto2File',image);
			await this.$http.post('usuariodistribuidor',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn = false;
				this.poBtnSave.toast = 1;
				$('#distribuidor').modal('hide');
                this.bus.$emit('List');
			}).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            }).finally(() => {
                this.ConfigLoad.ShowLoader = false;
            });
		},
		Limpiar(){
			this.Usuario={
				IdUsuario:0,
				Nombre:'',
				Apellido:'',
				Candado:'',
				Seguridad:'',
				Foto2:'',
				Distribuidor:1,
			};
			this.errorvalidacion=[];
		},
		get_one(){
			this.$http.get('usuariodistribuidor/recovery',{
				params:{
					IdUsuario:this.Usuario.IdUsuario
				}
			}).then((res)=>{
				const ObjRes=res.data.data.Usuario;
				this.Usuario.Nombre=ObjRes.Nombre;
				this.Usuario.Candado=ObjRes.Candado;
				this.Usuario.Seguridad=ObjRes.Seguridad;
				this.Usuario.Foto2=ObjRes.Foto2;
				this.Usuario.Distribuidor=ObjRes.Distribuidor;
				let Foto=ObjRes.Foto2;
				if (Foto != "" && Foto != null) {
					this.Foto = res.data.data.UrlFoto + ObjRes.Foto2;
				}
				this.readURL(this.Foto);
			})
		},
		readURL(input) {
			$$("#imagePreview").css("background-image", "url(" + this.Foto + ")");
			$$("#imagePreview").hide();
			$$("#imagePreview").fadeIn(650);
		},
		// CambiarImagen(target){
        //     this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreview'));
        // }
		CambiarImagen(){
			this.Usuario.Foto2 = this.$refs.file.files[0];
			const image = this.$refs.file.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Foto = e.target.result;
				this.readURL(this.Foto);
			};
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
		this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id)=>{
            // console.log("a");
            this.poBtnSave.disableBtn = false;
			this.bus.$off("Save_"+this.EmitSeccion);
			this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
			if (Id > 0) {
				this.Usuario.IdUsuario = Id;
				this.get_one();
			}
        });
	},
}
</script>

<style>

</style>
